import { useEffect, useMemo, useState } from 'react';
import { Squad } from '../../../types';
import { LevelLite } from '../../curriculum/adapters/types';
import { getCurriculumAdapterById } from '../../curriculum/adapters/registry';
import { subscribeManagedCurriculum } from '../../curriculum/services/curriculumService';
import { assignedLevels } from './curriculumAssignment';

export function useAssignedCurricula(squad: Pick<Squad, 'sessionPlan'>, baseId: string, baseLevels: LevelLite[]) {
  const idsKey = JSON.stringify(Array.from(new Set((squad.sessionPlan?.slots || []).map(slot => slot.curriculumId).filter((id): id is string => !!id))).sort());
  const [managed, setManaged] = useState<Record<string, LevelLite[]>>({});
  useEffect(() => {
    const ids: string[] = JSON.parse(idsKey);
    const unsubscribers = ids.map(id => subscribeManagedCurriculum(id, curriculum => {
      setManaged(previous => ({ ...previous, [id]: curriculum?.published !== false && curriculum?.levels?.length ? curriculum.levels : getCurriculumAdapterById(id).levels }));
    }, error => console.warn('Could not load assigned curriculum', id, error)));
    return () => unsubscribers.forEach(unsubscribe => unsubscribe());
  }, [idsKey]);
  return useMemo(() => {
    const curricula: Record<string, LevelLite[]> = { [baseId]: baseLevels };
    (JSON.parse(idsKey) as string[]).forEach(id => { curricula[id] = managed[id] || (id === baseId ? baseLevels : getCurriculumAdapterById(id).levels); });
    return squad.sessionPlan?.curriculumId === baseId ? assignedLevels(squad, baseLevels, curricula) : baseLevels;
  }, [squad, baseId, baseLevels, idsKey, managed]);
}
